import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
            <i className="ri-home-4-line" aria-hidden="true" />
            首页
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 line-clamp-1 max-w-[220px]">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}